import { ButtonComponent } from '../../UI/ButtonComponent/ButtonComponent';
import { DEFAULT_LABELS, description_list, ZIPFILE_LINK } from './model';
import './SocialMediaKitComponent.scss';

const handleDownload = () => {
	window.location.href = ZIPFILE_LINK;
};

export default function SocialMediaKitComponent() {
	return (
		<div className='brand-info-card socialmediakit'>
			<div className='title-container'>
				<h3>{DEFAULT_LABELS.title}</h3>
			</div>
			<div className='description-text'>
				<h3>{DEFAULT_LABELS.description_text} </h3>
			</div>
			<div className='description-list'>
				<h3>{DEFAULT_LABELS.list_heading}</h3>

				{description_list.map((ele, index) => (
					<p key={index}>
						<span>{ele.heading}: </span>
						{ele.item}
					</p>
				))}
			</div>
			<div className='description-download'>
				<h3>{DEFAULT_LABELS.description_download}</h3>
			</div>
			<div className='button-container'>
				<ButtonComponent
					text={DEFAULT_LABELS.button_text}
					onClick={handleDownload}
					style='rounded-button primary'
					icon={<i className='ri-arrow-right-s-line line-icon'></i>}
				/>
			</div>
			<div className='tip-box'>
				<div className='bulb-box'>
					<i className='ri-lightbulb-line bulb-style'></i>
				</div>
				<div className='description-box'>{DEFAULT_LABELS.tip_description}</div>
			</div>
		</div>
	);
}
